import * as React from 'react';
import { View } from 'react-native';
import { Colors } from '@qnpm/q-theme';
import { QLinearGradient } from 'qunar-react-native';
import BasicLabel from './components/BasicLabel';
import CombineLabel from './components/CombineLabel';
import Style from './style';
const { scenes: { lrGradientColors } } = Colors;
const DEFAULT_PROPS = {
    type: 'fill',
    fillType: 'basic',
    angleType: 'basic',
    size: 'medium',
    customStyle: {},
    needScale: false,
    needGradient: false,
    gradientColors: [lrGradientColors.leftColor, lrGradientColors.rightColor],
    accessibilityPreName: ''
};
export class Label extends React.PureComponent {
    constructor(props) {
        super(props);
        // 填充类
        this.getFillLabel = (data, defaultStyles) => {
            const { text, fillType, customStyle, needGradient, gradientColors, leftIcon, accessibilityPreName } = data;
            let basicStyle = defaultStyles.fillBasicStyle;
            if (!text) {
                return <View />;
            }
            if (fillType === 'full') {
                basicStyle = defaultStyles.fillWholeStyle;
            }
            const { textBgColor, textColor } = customStyle || {};
            let { wrapperStyle, textStyle } = basicStyle;
            // 仅支持用户修改背景色
            if (textBgColor) {
                wrapperStyle = Object.assign(Object.assign({}, wrapperStyle), { backgroundColor: textBgColor });
            }
            // 支持修改字体、边框色
            if (textColor) {
                textStyle = Object.assign(Object.assign({}, textStyle), { color: textColor });
            }
            return needGradient ? (<QLinearGradient colors={gradientColors} start={{ x: 0.0, y: 0.5 }} end={{ x: 1.0, y: 0.5 }} style={wrapperStyle}>
                <BasicLabel wrapperStyle={{}} text={text} leftIcon={leftIcon} textStyle={textStyle} accessibilityPreName={accessibilityPreName}/>
            </QLinearGradient>) : (<BasicLabel wrapperStyle={wrapperStyle} text={text} leftIcon={leftIcon} textStyle={textStyle} accessibilityPreName={accessibilityPreName}/>);
        };
        // 边框类
        this.getBorderLabel = (data, defaultStyles) => {
            const { text, textArray, customStyle, leftIcon, accessibilityPreName } = data;
            const basicStyle = defaultStyles.borderStyle;
            let { wrapperStyle, textStyle, splitStyle } = basicStyle;
            const { textBgColor, textColor, borderColor } = customStyle || {};
            if (!text && !textArray) {
                return <View />;
            }
            // 支持修改背景色
            if (textBgColor) {
                wrapperStyle = Object.assign(Object.assign({}, wrapperStyle), { backgroundColor: textBgColor });
            }
            // 支持修改字体、边框色
            if (textColor) {
                textStyle = Object.assign(Object.assign({}, textStyle), { color: textColor });
            }
            if (borderColor) {
                wrapperStyle = Object.assign(Object.assign({}, wrapperStyle), { borderColor: borderColor });
                splitStyle = Object.assign(Object.assign({}, splitStyle), { borderColor: borderColor });
            }
            return (<BasicLabel splitStyle={splitStyle} wrapperStyle={wrapperStyle} textArray={textArray} text={text} leftIcon={leftIcon} textStyle={textStyle} accessibilityPreName={accessibilityPreName}/>);
        };
        // 标题类
        this.getCombineLabel = (data, defaultStyles) => {
            const { text, title, textArray, customStyle, leftIcon, isReverse, maxLabelWidth, accessibilityPreName } = data;
            const basicStyle = defaultStyles.combineStyle;
            let { wrapperLeftStyle, wrappeRightStyle, textLeftStyle, textRightStyle, splitStyle } = basicStyle;
            const { titleBgColor, titleColor, textBgColor, textColor, borderColor } = customStyle || {};
            if (!title || (!text && !textArray)) {
                return <View />;
            }
            // 支持修改标题背景色
            if (titleBgColor) {
                wrapperLeftStyle = Object.assign(Object.assign({}, wrapperLeftStyle), { backgroundColor: titleBgColor });
            }
            // 支持修改标题字体色
            if (titleColor) {
                textLeftStyle = Object.assign(Object.assign({}, textLeftStyle), { color: titleColor });
            }
            // 支持修改标题背景色
            if (textBgColor) {
                wrappeRightStyle = Object.assign(Object.assign({}, wrappeRightStyle), { backgroundColor: textBgColor });
            }
            // 支持修改字体色
            if (textColor) {
                textRightStyle = Object.assign(Object.assign({}, textRightStyle), { color: textColor });
            }
            if (borderColor) {
                splitStyle = Object.assign(Object.assign({}, splitStyle), { borderColor: borderColor });
                wrappeRightStyle = Object.assign(Object.assign({}, wrappeRightStyle), { borderColor: borderColor });
                wrapperLeftStyle = Object.assign(Object.assign({}, wrapperLeftStyle), { borderColor: borderColor });
            }
            return (<CombineLabel title={title} splitStyle={splitStyle} wrapperLeftStyle={wrapperLeftStyle} wrappeRightStyle={wrappeRightStyle} textRightStyle={textRightStyle} textArray={textArray} text={text} leftIcon={leftIcon} textLeftStyle={textLeftStyle} isReverse={isReverse} maxLabelWidth={maxLabelWidth} labelPadding={this.style.labelAngleFullPadding} spliteMargin={this.style.spliteMargin} accessibilityPreName={accessibilityPreName}/>);
        };
        // 角标类
        this.getAngleLabel = (data, defaultStyles) => {
            const { text, angleType, customStyle, needGradient, gradientColors, leftIcon, accessibilityPreName } = data;
            let basicStyle = defaultStyles.angleBasicStyle;
            if (angleType === 'full') {
                basicStyle = defaultStyles.angleFullStyle;
            }
            const { textBgColor, textColor } = customStyle || {};
            let { wrapperStyle, textStyle } = basicStyle;
            // 背景可改
            if (textBgColor) {
                wrapperStyle = Object.assign(Object.assign({}, wrapperStyle), { backgroundColor: textBgColor });
            }
            // 字体颜色
            if (textColor) {
                textStyle = Object.assign(Object.assign({}, textStyle), { color: textColor });
            }
            return needGradient ? (<QLinearGradient colors={gradientColors} start={{ x: 0.0, y: 0.5 }} end={{ x: 1.0, y: 0.5 }} style={wrapperStyle}>
                <BasicLabel wrapperStyle={{}} leftIcon={leftIcon} textStyle={textStyle} text={text} accessibilityPreName={accessibilityPreName}/>
            </QLinearGradient>) : (<BasicLabel leftIcon={leftIcon} wrapperStyle={wrapperStyle} textStyle={textStyle} text={text} accessibilityPreName={accessibilityPreName}/>);
        };
        this.style = new Style(props.needScale, props.needGradient, props.size);
    }
    render() {
        const data = this.props;
        const { type } = data;
        let labelView = <View />;
        const defaultStyles = this.style.getStyle();
        switch (type) {
            case 'fill': {
                labelView = this.getFillLabel(data, defaultStyles);
                break;
            }
            case 'border': {
                labelView = this.getBorderLabel(data, defaultStyles);
                break;
            }
            case 'combine': {
                labelView = this.getCombineLabel(data, defaultStyles);
                break;
            }
            case 'angle': {
                labelView = this.getAngleLabel(data, defaultStyles);
                break;
            }
            default:
                break;
        }
        return labelView;
    }
}
Label.defaultProps = DEFAULT_PROPS;
